const encodeQueryData = (obj) => Object.entries(obj).map(([key, val]) => val ? `${key}=${val}`: '').join('&');

export default encodeQueryData;